import { Spacer } from "shared/layout";
import styled from "styled-components";

export const NotFlexSpacer = styled(Spacer)`
  @media print {
    display: block;
  }
`;
